import CrearSurvivorFormulario, { ListaPremios, Torneos, WizardButtons  } from './CrearSurvivorFormulario';

export { ListaPremios, Torneos, WizardButtons  };

export default CrearSurvivorFormulario;
